import styled from '@emotion/styled';
import * as React from 'react';
import { colors, fontWeight } from '~/styles/constants';

const BackButtonContainer = styled('div')`
  display: flex;
  padding: 14px 24px 14px 24px;
  border-bottom: 1px solid #efefef;
  margin-bottom: 14px;
  cursor: pointer;
  color: ${colors.fontColor};
  font-size: 14px;
  align-items: center;
  font-weight: ${fontWeight.medium};

  i {
    color: ${colors.placeholderColor};
    margin-right: 14px;
  }
`;

interface BackButtonProps {
  onClick: (e: React.MouseEvent) => void;
}

const BackButton = (props: BackButtonProps) => {
  return (
    <BackButtonContainer onClick={props.onClick}>
      <i className="fa fa-chevron-left" />
      Carrier Provided Parcels
    </BackButtonContainer>
  );
};

export default BackButton;
